import AmpEvents from '@amplify/amp-events';
import { types } from './lrsActions';
import getEnvironmentName from './lrsHelpers';
import packageJson from '../../../package.json';

const APP_NAME = 'Flex';
// Copied version from package.json.
const APP_VERSION = packageJson.version;

const ENV = getEnvironmentName();

const LANGUAGE = 'en-US';

export const initLRS = () => {
    const eventFactory = new AmpEvents({
        [AmpEvents.OPTIONS.APP_NAME]: APP_NAME,
        [AmpEvents.OPTIONS.APP_VERSION]: APP_VERSION,
        [AmpEvents.OPTIONS.LANGUAGE]: LANGUAGE,
        [AmpEvents.OPTIONS.ENVIRONMENT]: ENV,
    });
    return eventFactory;
};

export const createLRSMiddleware = () => {
    let lrs;
    try {
        lrs = initLRS();
    } catch {
        // If unable to init LRS lib - do not break middleware chain.
        return () => next => action => next(action);
    }

    return () => next => action => {
        if (action.type === types.TRACK_EVENT) {
            let trackerObject;
            try {
                trackerObject = lrs.eventFactory
                    .create()
                    .addActorAccount('name', `urn:amplify:mclass-student:${action.userId}`)
                    .addVerbId(action.verbId)
                    .addVerb('display', { [LANGUAGE]: action.verbId })
                    .addObject('id', action.objectId)
                    .addObjectExtension('page-element-type', action.elementType)
                    .addContextExtension('app-name', APP_NAME);
                if (action.assessment) {
                    trackerObject.addContextExtension('assessment', action.assessment);
                }
                if (action.measure) {
                    trackerObject.addContextExtension('measure', action.measure);
                }
                if (action.additionalContext) {
                    Object.entries(action.additionalContext).forEach(([key, value]) =>
                        trackerObject.addContextExtension(key, value),
                    );
                }
                if (ENV === 'devci') {
                    // Show event data in console
                    // eslint-disable-next-line no-console
                    console.log('amp-events statement', trackerObject.statement);
                }
                trackerObject.emit();
            } catch {
                // If unable to create or emit LRS event - do not break middleware chain.
                return next(action);
            }
        }
        return next(action);
    };
};

export const lrsMiddleware = createLRSMiddleware();

export default lrsMiddleware;
